module.exports = __webpack_public_path__ + "static/temple-logo-white-1ffacadd3ebb03497b8591603c9b6dcf.png";